import api from "./api";

class Service {

    static myInstance = null;

    static getInstance() {
        if (Service.myInstance == null) {
            Service.myInstance = new Service();
        }
        return this.myInstance;
    }

    async get(url, config) {
        return await api.get(url, config);
    }

    async post(url, objeto, config) {
        const response = await api.post(url, objeto, config);
        return response;
    }

    async patch(url, objeto) {
        return api.patch(url, objeto);
    }

    async put(url, objeto) {
        return api.put(url, objeto);
    }

    async delete(url, objeto) {
        const resp = await api.delete(url, objeto);
        return resp;
    }

    async upload(url, formData, config) {
        const resp = await api.post(url, formData, config);
        return resp;
    }

    async download(url) {
        const resp = await api.get(url, { responseType: 'blob' });
        return resp;
    }

}

export default Service;